
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { EmojiReactions } from '../../entities/chat'
import vClickOutside from 'v-click-outside'
import { updateEmoji } from '@/api/chat'

@Component<EmojiReaction>({
    directives: {
        clickOutside: vClickOutside.directive,
    },
})
export default class EmojiReaction extends Vue {
    @Prop(Object) public emojis!: EmojiReactions
    @Prop() public relid!: string | number
    @Prop(String) public type!: string
    // single mode is on left, while list mode is at bottom of msg
    // single mode only shows when there are no emojis at all
    @Prop(Number) public singleMode!: number
    @Prop(String) public firstname!: string
    @Prop(Boolean) public isMobile!: boolean

    public lastEmoji = false // emoji to animate: zoom when you click
    public showEmojis = false
    public emoji2class = {
        '👍': 'thumsup',
        '👎': 'thumsdown',
        '😄': 'smile',
        '🎉': 'tada',
        '🙁': 'frown',
        '❤️': 'heart',
        '🥝': 'kiwi',
    }

    public get emojiKeysNum() {
        return Object.keys(this.emojis || {}).length
    }

    public hideEmojiPopup() {
        this.showEmojis = false
    }

    public get class2emojis() {
        const ret = {}
        for (const key in this.emoji2class) {
            if (this.emoji2class.hasOwnProperty(key)) {
                ret[this.emoji2class[key]] = key
            }
        }
        return ret
    }

    public processReaction(e) {
        const reaction = this.class2emojis[e.target.dataset.emoji]
        this.hideEmojiPopup()

        if (
            this.emojis[reaction] &&
            this.emojis[reaction].length &&
            this.emojis[reaction].indexOf(this.firstname) !== -1
        ) {
            if (this.emojis[reaction].length === 1) {
                //  if only one emoji, when remove, remove whole array completely, not leaving empty array
                Vue.delete(this.emojis, reaction)
            } else {
                Vue.delete(
                    this.emojis[reaction],
                    this.emojis[reaction].indexOf(this.firstname)
                )
            }
            this.lastEmoji = false
        } else {
            if (!this.emojis[reaction]) {
                Vue.set(this.emojis, reaction, [])
            }
            Vue.set(
                this.emojis[reaction],
                this.emojis[reaction].length || 0,
                this.firstname
            )
            this.lastEmoji = reaction
        }

        // try best, don't wait for it to finish
        updateEmoji(this.type, this.relid, reaction)
    }

    // generate tooltip for emojis telling who reacted with this emoji
    public getEmojiTooltip(names) {
        return names.join(', ') + ' reacted'
    }

    public toggleEmojis() {
        this.showEmojis = !this.showEmojis
    }
}
